<template>
    <div>
        <b-row>
          <b-col>
              <b-card>
                <div slot="header">
                  <strong> Transporter Master(Rejected)</strong>
                  <div class="card-header-actions">
                    <!-- <button class="btn btn-sm btn-primary mr-4 btn-pill" type="button" @click="toggleTransporterInfo" :disabled="isReadOnly">
                        Add New
                    </button> -->
                  </div>
                </div>
                
                <b-row>
                    <b-col sm="12">
                        <div>
                            <b-card v-if="addInfoCard">
                              <b-form @submit.prevent="addTransporterForm('form-1')" data-vv-scope="form-1">
                                <b-row>
                                  <b-col sm="6">
                                    <b-form-group>
                                        <label for="Company Name">Company Name</label>&nbsp;<span style="color: red;">*</span>
                                        <b-form-input type="text" name="Company Name"
                                        v-model="transporterObj.transporter_company_name" v-validate="'required|min:3|max:50'" :class="{ input: true, 'is-invalid': errors.has('form-1.Company Name'),
                                        }"
                                        placeholder="Enter Company Name"
                                        >
                                        </b-form-input>
                                        <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i
                                            class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-1.Company Name')"
                                            >{{ errors.first("form-1.Company Name") }}</i
                                            >
                                        </span>
                                        </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col sm="6">
                                    <b-form-group>
                                        <label for="Owner Name">Company Owner Name</label>&nbsp;<span style="color: red;">*</span>
                                        <b-form-input type="text" name="Owner Name"
                                        v-model="transporterObj.transporter_name" v-validate="'required|min:3|max:30'" :class="{ input: true, 'is-invalid': errors.has('form-1.Owner Name'),
                                        }"
                                        placeholder="Enter Company Owner Name"
                                        >
                                        </b-form-input>
                                        <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i
                                            class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-1.Owner Name')"
                                            >{{ errors.first("form-1.Owner Name") }}</i
                                            >
                                        </span>
                                        </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col sm="6">
                                    <b-form-group>
                                        <label for="Email Id">Company Email Id</label>&nbsp;<span style="color: red;">*</span>
                                        <b-form-input type="text" name="Email Id"
                                        v-model="transporterObj.transporter_emailid" v-validate="'required|email'" :class="{ input: true, 'is-invalid': errors.has('form-1.Email Id'),
                                        }"
                                        placeholder="Enter Company Email Id"
                                        >
                                        </b-form-input>
                                        <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i
                                            class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-1.Email Id')"
                                            >{{ errors.first("form-1.Email Id") }}</i
                                            >
                                        </span>
                                        </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col sm="6">
                                    <b-form-group>
                                        <label for="Mobile Number">Company Mobile Number</label>&nbsp;<span style="color: red;">*</span>
                                        <b-form-input type="text" name="Mobile Number"
                                        v-model="transporterObj.transporter_mobilenumber" v-validate="'required|digits:10'" :class="{ input: true, 'is-invalid': errors.has('form-1.Mobile Number'),
                                        }" maxlength="10"
                                        placeholder="Enter Company Mobile Number"
                                        >
                                        </b-form-input>
                                        <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i
                                            class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-1.Mobile Number')"
                                            >{{ errors.first("form-1.Mobile Number") }}</i
                                            >
                                        </span>
                                        </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col sm="6">
                                    <b-form-group>
                                        <label for="Password">Password</label>&nbsp;<span style="color: red;">*</span>
                                        <b-form-input name="Password" type="password"
                                        minlength="6" maxlength="14" v-model="transporterObj.password"
                                        v-validate="'required|min:6|max:14'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-1.Password'),
                                        }"
                                        placeholder="Enter Password">
                                        </b-form-input>
                                        <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i
                                            class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-1.Password')"
                                            >{{ errors.first("form-1.Password") }}</i
                                            >
                                        </span>
                                        </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col sm="6">
                                    <b-row>
                                      <b-col :sm="!transporterObj.gstnumber?12:9" :class="transporterObj.gstnumber!=''?'pr-0':'pr-3'">
                                        <b-form-group>
                                          <label for="GSTNumber">Tin Number / GST Number</label>
                                          <b-form-input name="GST Number" type="text"
                                          v-model="transporterObj.gstnumber" @input="checkGSTlength(transporterObj.gstnumber)" 
                                          placeholder="Enter Tin Number / GST Number"
                                          :class="{ input: true, 'is-invalid': errors_GST,
                                          }">
                                          </b-form-input>
                                          <b-input-group class="mb-3">
                                            <span class="icon has-text-warning" v-if="errors_GST">
                                              <i
                                              class="fa fa-warning help text-danger"
                                              >{{ errors_showGST.transporter_gstnumber }}</i
                                              >
                                          </span>
                                          </b-input-group>
                                      </b-form-group>
                                      </b-col>
                                    
                                      <b-col :sm="!transporterObj.gstnumber?0:3"  class="mt-1 pr-0">
                                        <button type="button" class="btn btn-outline-success btn-md mt-4" v-if="addshowverifybutton" @click="verifyGSTNo()">Verify</button>&nbsp;
                                        <button type="button" class="btn btn-outline-danger btn-md mt-4" v-if="removeGST" @click="removevalue()">X</button>
                                      </b-col>
                                    </b-row>
                    
                                  </b-col>
                                  <b-col sm="6">
                                    <b-form-group>
                                      <label for="Transport Serviceability">Transport Serviceability</label>&nbsp;<span style="color: red;">*</span>
                                      <b-form-select  class="mb-3" name="Transport Serviceability"
                                      v-model="transporterObj.transportserviceability" v-validate="'required|'" :class="{ input: true, 'is-invalid': errors.has('form-1.Transport Serviceability'),
                                      }">
                                        <option :value="selected">Please select an option</option>
                                        <option value="local">Local</option>
                                        <option value="state">State</option>
                                        <option value="regional">Regional</option>
                                        <option value="national">National</option>
                                      </b-form-select>
                                      <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i
                                            class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-1.Transport Serviceability')"
                                            >{{ errors.first("form-1.Transport Serviceability") }}</i
                                            >
                                        </span>
                                        </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                                <footer class="column has-text-right">
                                <b-button variant="primary" size="md" type="submit" id="submitButton">Add</b-button>
                                </footer>
                              </b-form>
                              
                            </b-card>
                        </div>
                    </b-col>
                </b-row>

                <b-row>
                  <b-col sm="4">
                    <b-form-group label-cols-md="2" label="Filter" class="mb-0">
                        <b-input-group>
                          <b-form-input
                             v-model="filter"
                             placeholder="Enter Id/Name"
                             class="w-60"  
                          ></b-form-input>

                        <!-- <b-form-input
                            v-model="filter"
                            placeholder="Type to Search"
                        ></b-form-input> -->
                        <b-col sm="4">    
                    <b-button 
                      @click="getTransporterList()"
                      size="md"
                      variant="primary"
                      >Search</b-button>
                      </b-col>
                    &nbsp;
                    <b-button @click="clearSearch()" size="md" variant="danger"
                      >Clear</b-button> 
                          <!-- <b-button
                      @click="getTransporterList()"
                      size="sm"
                      variant="primary"
                      >Search</b-button>
                            <b-button :disabled="!filter" @click="filter = ''"
                            >Clear</b-button> -->
                        
                        </b-input-group>
                    </b-form-group>
                 </b-col>
                    <b-col sm="5">
                     <b-form-group label-cols-sm="4" label="Approval Level:" class="mb-0">
                          <b-form-select v-model="selectedApprovalLevel" @change="handleFilterChange">
                            <option value="">All Levels</option>
                            <option value="1">L1</option>
                            <option value="2">L2</option>
                            <option value="3">L3</option>
                          </b-form-select>
                        </b-form-group>
                    </b-col>

                    <b-col sm="3" class="text-right">
                        <p>
                            <b>Total Records :<span style="color:red;">{{totalRows}}</span></b
                            >
                        </p>
                    </b-col>
                    <b-col sm="12">
                        <b-table show-empty responsive :items="transporter_data" :busy="isBusy"  :current-page="currentPage" :fields="fields" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :bordered="bordered">
                          <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                          </div>
                          <template slot="tingstnumber" slot-scope="row">
                            <div>
                                {{ row.item.transporter_gst_no  }}
                            </div>
                          </template>
                          <template slot="isactive" slot-scope="row">
                            <span
                              @click="toggleInfoModal(row.item)"
                              style="cursor:pointer;"
                            >
                              <span
                                data-toggle="tooltip"
                                title="InActive"
                                v-if="row.item.isactive === '0'"
                              >
                                <span class="badge badge-danger">Inative</span>
                              </span>
                              <span data-toggle="tooltip" title="Active" v-else>
                                <span class="badge badge-success">Active</span>
                              </span>
                            </span>
                          </template>
                          <template slot="createddate" slot-scope="row">
                            <div>
                                {{ row.item.createddate | ConvertTime12hour() }}
                            </div>
                          </template>

                          <template slot="lastmodifieddate" slot-scope="row">
                            <div>
                                {{ row.item.lastmodifieddate | ConvertTime12hour() }}
                            </div>
                          </template>
                       <template slot="invoice_status" slot-scope="row">                           
                            {{ formatStatus(row.item) }}
                          </template>
                          <template slot="reason" slot-scope="row">
                            <p>{{ row.item.reject_reason }}</p>
                            <p><b-button variant="primary"  class="custom-submit" size="sm" @click="transporterMasterLog(row.item.transporter_id)">Log</b-button>
</p>
                          </template>
                        </b-table>
                    </b-col>
                </b-row>

                <b-row>
                  <b-col md="6" class="my-1" v-if="totalRows>20">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                
                  </b-col> 
                </b-row>

                
                <b-modal  title="Update Transporter Info"  size="lg" v-model="updateInfo" @ok="updateInfo==false" hide-footer>
                  <b-row>
                    <b-col sm="12">   
                      <b-form @submit.prevent="editTransporterForm('form-1')" data-vv-scope="form-1">
                            <b-row>
                              <b-col sm="6">
                                <b-form-group>
                                    <label for="Company Name">Company Name</label>&nbsp;<span style="color: red;">*</span>
                                    <b-form-input type="text" name="Company Name"
                                    v-model="updatetransporterObj.transporter_company_name" v-validate="'required|min:3|max:50'" :class="{ input: true, 'is-invalid': errors.has('form-1.Company Name'),
                                    }"
                                    placeholder="Enter Company Name"
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                        <i
                                        class="fa fa-warning help text-danger"
                                        v-show="errors.has('form-1.Company Name')"
                                        >{{ errors.first("form-1.Company Name") }}</i
                                        >
                                    </span>
                                    </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-col sm="6">
                                <b-form-group>
                                    <label for="Owner Name">Company Owner Name</label>&nbsp;<span style="color: red;">*</span>
                                    <b-form-input type="text" name="Owner Name"
                                    v-model="updatetransporterObj.transporter_name" v-validate="'required|min:3|max:30'" :class="{ input: true, 'is-invalid': errors.has('form-1.Owner Name'),
                                    }"
                                    placeholder="Enter Company Owner Name"
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                        <i
                                        class="fa fa-warning help text-danger"
                                        v-show="errors.has('form-1.Owner Name')"
                                        >{{ errors.first("form-1.Owner Name") }}</i
                                        >
                                    </span>
                                    </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-col sm="6">
                                <b-form-group>
                                    <label for="Email Id">Company Email Id</label>&nbsp;<span style="color: red;">*</span>
                                    <b-form-input type="text" name="Email Id"
                                    v-model="updatetransporterObj.transporter_emailid" v-validate="'required|email'" :class="{ input: true, 'is-invalid': errors.has('form-1.Email Id'),
                                    }"
                                    placeholder="Enter Company Email Id"
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                        <i
                                        class="fa fa-warning help text-danger"
                                        v-show="errors.has('form-1.Email Id')"
                                        >{{ errors.first("form-1.Email Id") }}</i
                                        >
                                    </span>
                                    </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-col sm="6">
                                <b-form-group>
                                    <label for="Mobile Number">Company Mobile Number</label>&nbsp;<span style="color: red;">*</span>
                                    <b-form-input type="text" name="Mobile Number"
                                    v-model="updatetransporterObj.transporter_mobilenumber" v-validate="'required|digits:10'" :class="{ input: true, 'is-invalid': errors.has('form-1.Mobile Number'),
                                    }" maxlength="10"
                                    placeholder="Enter Company Mobile Number"
                                    >
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                        <i
                                        class="fa fa-warning help text-danger"
                                        v-show="errors.has('form-1.Mobile Number')"
                                        >{{ errors.first("form-1.Mobile Number") }}</i
                                        >
                                    </span>
                                    </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-col sm="6">
                                <b-form-group>
                                  <label for="GSTNumber">Tin Number / GST Number</label>
                                  <b-form-input name="GST Number" type="text"
                                  v-model="updatetransporterObj.gstnumber" @input="updatecheckGSTlength(updatetransporterObj.gstnumber)" 
                                  placeholder="Enter Tin Number / GST Number"
                                  :class="{ input: true, 'is-invalid': update_errors_GST,
                                  }">
                                  </b-form-input>
                                  <b-input-group class="mb-3">
                                    <span class="icon has-text-warning" v-if="update_errors_GST">
                                      <i
                                      class="fa fa-warning help text-danger"
                                      >{{ update_errors_showGST.transporter_gstnumber }}</i
                                      >
                                  </span>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-col sm="6" class="mt-1">
                                <button type="button" class="btn btn-outline-success btn-md mt-4" v-if="showverifybutton" @click="updateverifyGSTNo()">Verify</button>&nbsp;
                                <button type="button" class="btn btn-outline-danger btn-md mt-4" v-if="update_removeGST" @click="updateremovevalue()">X</button>
                              </b-col>
                            </b-row>
                            <footer class="column has-text-right">
                              <div id="overlayModal">
                                <div class="loaderModal"></div>
                              </div>
                            <div class="text-right">
                              <b-button variant="primary" size="md" type="submit" id="submitButton1">Edit</b-button>
                            </div>
                            </footer>
                      </b-form>
                    </b-col>
                  </b-row>
                </b-modal>
                 <!-- Transporter Log Popup Modal -->
                <b-modal ref="transporterLogModal" title="Transporter Log Details" hide-footer  size="xl">
                  <div id="listloader" v-if="loader">
                      <div class="listloader"></div>
                      <br/>
                      <span class="loading" style="color:#fff;">Loading...</span>
                    </div>
                    <div>
                      <table class="table table-bordered mt-3">
                        <thead>
                          <tr>
                            <th>           
                            Sr.no
                            </th>
                             <th>Transporter ID</th>
                            <th>Status</th>
                            <th>Createdby</th>                           
                            <th>User Approval Level</th>
                             <th>Total Approval Levels</th>
                              <th>Reject Reason</th>
                            <th>Created Date</th>
                          </tr>
                        </thead>
                        <tbody v-if="arrTransporterLog.length > 0">
                          <tr v-for="(item, index) in arrTransporterLog" :key="index">
                            <td>{{(index+1)}}</td>
                            <td>{{ item.transporter_id }}</td>
                            <td>{{ item.status }}</td>
                            <td>{{ item.createdby }}</td>
                            <td>{{ item.user_approval_level }}</td>
                            <td>{{ item.total_approval_levels }}</td>
                            <td>{{ item.reject_reason ||'-' }}</td>
                            <td>{{ formatDate(item.createdat) }}</td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="8">Records Not Created By Transporter</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>    
                    <!-- Footer with Approve and Reject with Remark Buttons -->
                    <div class="text-right mt-3"  v-if="arrTransporterLog.length > 0">    
                      <b-button variant="secondary" @click="$refs.transporterLogModal.hide()">Close</b-button>
                    </div>    
                </b-modal>
                <!-- Confirmation Box -->
                <b-modal 
                title="Confirmation Box" v-model="toggleInfo" size="md"  @ok="toggleInfo =false"
                >
                  <template slot="modal-header" slot-scope="{ close }">
                    <h5>Confirmation Box</h5>
                  </template>
                  <template slot="default" slot-scope="{ hide }">
                    <form v-on:submit.prevent="activateinactivateTransporter(value)">
                      <div class="modal-background"></div>
                      <div class="modal-card">
                        <section class="modal-card-body">
                          <input
                            type="hidden"
                            v-model="customer.isactive"
                            name="isactive"
                            id="modalIsActiveChk"
                          />
                          <span>Are you sure you want to change the status?</span>
                        </section>
                        <footer>
                          <b-button variant="primary" size="sm" type="submit">Ok</b-button>
                        </footer>
                      </div>
                    </form>
                  </template>
                  <template slot="modal-footer" slot-scope="{ cancel }">
                    <!-- Emulate built in modal footer ok and cancel button actions -->
                    <b-button size="sm" variant="danger" @click="cancel()">
                      Cancel
                    </b-button>
                  </template>
                </b-modal>
 
              </b-card>
          </b-col>
        </b-row>
    </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from "vue";
export default {
    data(){
        return {
            selectedApprovalLevel: "", 
            transporterObj:{
              transportserviceability:''
            },
            totalRows:0,
            fields: [
                { key: "transporter_id", label: "Register ID", sortable: true },
                { key: "transporter_company_name", label: "Company Name", sortable: true },
                { key: "transporter_name", label: "Owner Name", sortable: true },
                { key: "transporter_emailid", label: "Email Id", sortable: true },
                { key: "transporter_mobilenumber", label: "Mobile Number", sortable: true },
                { key: "tingstnumber", label: "TIN/GST Number", sortable: true },
                // { key: "createdby", label: "Created By", sortable: true },
                {key: 'registered_from', label: 'Registered from', sortable: true},
                 {key: 'invoice_status', label: 'Approval Status', sortable: true},
                {key: 'no_of_levels', label: 'No Of Levels', sortable: true},
                // { key: "isactive", label: "Status", sortable: true },
                { key: "createddate", label: "Created Date", sortable: true },
                { key: "lastmodifiedby", label: "Last Modified By",sortable: true},
                { key: "lastmodifieddate", label: "Last Modified Date",sortable: true},
                { key: "reason", label: "Reason",sortable: true},
                { key: "isactive", label: "IsActive", sortable: true },
            ],
            transporter_data:[],
            bordered: true,
            currentPage: 1,
            perPage: 20,
            pageOptions: [5, 10, 15],
            sortBy: null,
            sortDesc: false,
            sortDirection: "asc",
            filter:'',
            isBusy:false,
            addInfoCard:false,
            updateInfo:false,
            updatetransporterObj :{},
            // add
            errors_GST:false,
            errors_showGST:{},
            removeGST:false,
            addshowverifybutton:false,
            // edit
            update_errors_GST:false,
            update_errors_showGST:{},
            update_removeGST:false,
            showverifybutton:false,
            accessBody:[],
            isReadOnly:false,
            arrTransporterLog: [],
            tripLevelInvoiceApproval: null,
            tripLevelInvoiceApprovalLevel:'',
            toggleInfo: false,
            customer :{},
        }
    },
    created(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.accessBody = userInfo.body;
   

      if (userdata) {
        
        if (userInfo && Array.isArray(userInfo.approval_action)) {
          this.tripLevelInvoiceApproval = userInfo.approval_action.find(
            action => action.module === "vendor_onboarding"
          ) || null;
        } else {
          this.tripLevelInvoiceApproval = null;
        }
        // Log the result (or handle it as needed)
        if (this.tripLevelInvoiceApproval && this.tripLevelInvoiceApproval.level) {
          this.tripLevelInvoiceApprovalLevel = this.tripLevelInvoiceApproval.level.replace('l', '');
          this.selectedApprovalLevel=this.tripLevelInvoiceApprovalLevel;

        }
        console.log('tripLevelInvoiceApproval Level',this.tripLevelInvoiceApprovalLevel);
      }
    this.ischeckbodyvalidation();
        this.getTransporterList();
    },
    methods:{
      toggleInfoModal: function(value) {
      this.customer = value;

      this.toggleInfo = !this.toggleInfo;
    },

    activateinactivateTransporter: function(value) {
      var activeInactiveVal;
      if (this.customer.isactive === "1") {
        activeInactiveVal = "0";
        // console.log("activeInactiveVal",activeInactiveVal);
      } else {
        activeInactiveVal = "1";
        // console.log("activeInactiveVal1",activeInactiveVal);
      }
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const customerGetobj = {
        // deliveryagentmasterid: deliveryagentmasterId,
        transporterId: this.customer.transporter_id,
        isactive: activeInactiveVal,
        lastmodifiedby:
          `${userInfo.userfirstname}` + " " + `${userInfo.userlastname}`,
      };
      console.log("JJJJJJJJ", customerGetobj);
      // return false;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/activateinactivateTransporter`,
        customerGetobj)
      .then((result) => {
        console.log("result", result);
        if (result.body.returnmsg === "Successfull") {
          // alert("Shipments are Allocated so can not InActive");
          this.$fire({
            text: "Status Changed Successfully",
            type: "success",
            timer: 30000,
          });

          this.toggleInfo = false;
          this.getTransporterList();
        } else {
          this.$fire({
            text: result.body.returnvalue,
            type: "error",
            timer: 30000,
          });
          this.toggleInfo = false;
        }
      })
      .catch((ex) => {
        console.log("error", ex);
      });
    },
    formatStatus(item) {
      // Assuming both fields exist in the item object
      const invoiceStatus = item.approver_status || 'N/A'; // Default if null
      const nextReviewer = item.nextreviewer ? `L${item.nextreviewer}` : ''; // Prefix with 'L' if exists
      // Return values based on condition
      return nextReviewer ? `${nextReviewer} - ${invoiceStatus}` : invoiceStatus;
    },
      formatDate(date) {
        if (!date) return 'N/A'; // Fallback if date is null or undefined
        const parsedDate = new Date(date);
        return parsedDate.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
      },
      transporterMasterLog(transporter_id) {   
        console.log('transporterMasterLog',transporter_id);
        this.remark = '';
        this.loader = true;
        const obj = {
          transporterId: transporter_id
        };
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTransporterMasterLog`, obj).then(result => {
          console.log('getTransporterMasterLog',result.body);
          this.loader = false;
          if (result.body.returnstatus === 'Successful') {
            this.arrTransporterLog = result.body.returnvalue;
          } else {
            this.arrTransporterLog = [];
          }
        }).catch(ex => {
          console.error('Error fetching invoice list:', ex);
        }).finally(() => {
          this.loader = false;
        });

        // Show dispute confirmation modal
        this.$refs.transporterLogModal.show();
      },
      ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='Transporter Master' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Transporter Master' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
      handleFilterChange() {
        console.log("Selected Approval Level:", this.selectedApprovalLevel);
        this.tripLevelInvoiceApprovalLevel=this.selectedApprovalLevel;
        this.getTransporterList();
      },
      getTransporterList(){
            this.isBusy=false;
            const approvalLevel = this.tripLevelInvoiceApprovalLevel != null ? this.tripLevelInvoiceApprovalLevel : "";

            const Obj = {
                status: "Rejected",
                tripLevelInvoiceApprovalLevel:approvalLevel, 
                vehiclefilter: this.filter==null?'':this.filter,
            };
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getTransporterEmailIdListNew`, Obj).then((result)=>{
            this.isBusy=false;
          if (result.body.returnmsg === "Successful") {
            this.transporter_data=result.body.returnvalue;
            this.totalRows=result.body.returnvalue.length;
          } else {
            this.transporter_data=[];
            this.totalRows=0;
          }
        }).catch((ex) => {
          console.log("error", ex);
        });
      },

      toggleTransporterInfo(){
        this.addInfoCard = !this.addInfoCard;
        this.transporterObj={};
      },

      checkGSTlength(value){
        if (value.length>0) {
          this.addshowverifybutton=true;
          document.getElementById("submitButton").disabled = true; 
        }
        else{
          this.addshowverifybutton=false;
          this.transporterObj.gstnumber='';
          this.errors_GST = false;
          this.errors_showGST= {};
          document.getElementById("submitButton").disabled = false;
          this.removeGST=false;
        }
      },

      verifyGSTNo(){
        document.getElementById("overlay").style.display = "block";
          const infoObj = {
            Gstin:this.transporterObj.gstnumber,
          };
          console.log("infoObj",infoObj);
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validateGSTNO`, infoObj).then((result)=>{
            console.log("result",result)
            document.getElementById("overlay").style.display = "none";
            if (result.body === "success") {
              document.getElementById("submitButton").disabled = false;
              this.addshowverifybutton=false;
              this.$fire({
                text: 'Successful Verify',
                type: "success",
                timer: 30000,
              });
              this.errors_GST = false;
              this.errors_showGST.transporter_gstnumber=''
              this.removeGST=false;
            } else {
              this.errors_GST = true;
              this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
              this.removeGST=true;
            }
          }).catch((ex) => {
            console.log("error", ex);
          });
        // if (this.transporterObj.gstnumber) {
        //   this.errors_GST = true;
        //   this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
        //   this.removeGST=true;
        //   return false;
        // }
        // else{
        //   document.getElementById("submitButton").disabled = false;
        // }
      },

      removevalue(){
        this.addshowverifybutton=false;
        this.transporterObj.gstnumber='';
        this.errors_GST = false;
        this.errors_showGST= {};
        document.getElementById("submitButton").disabled = false;
        this.removeGST=false;
      },

      addTransporterForm(scope){
        this.$validator.validateAll(scope).then((result) => {
          console.log("result",result)
        if (result) {
            this.addTransporterInfo();
        }
        });
      },

      addTransporterInfo(){
        document.getElementById("overlay").style.display = "block";
        let userdata = localStorage.getItem("userData");
        let userInfo = JSON.parse(userdata);
            const infoObj = {
                transporter_company_name:this.transporterObj.transporter_company_name,
                transporter_name:this.transporterObj.transporter_name,
                transporter_emailid:this.transporterObj.transporter_emailid,
                transporter_mobilenumber:this.transporterObj.transporter_mobilenumber,
                transporter_gstnumber:`${this.transporterObj.gstnumber}`,
                password:this.transporterObj.password,
                createdby:`${userInfo.sysemailid}`,
                transportserviceability:this.transporterObj.transportserviceability,
               
            };
            console.log("infoObj",infoObj);
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/InsertTransporterInfoNew`, infoObj).then((result)=>{
          document.getElementById("overlay").style.display = "none";
          if (result.body.returnmsg === "Successful") {
            this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 30000,
            });
            this.getTransporterList();
            this.toggleTransporterInfo();
           
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        }).catch((ex) => {
          console.log("error", ex);
        });
      },

      updateModal(data){
        this.addInfoCard = false
        // console.log("data",data);
        this.updatetransporterObj={};
        this.updatetransporterObj.transporter_id=data.transporter_id
        this.updatetransporterObj.transporter_company_name =data.transporter_company_name
        this.updatetransporterObj.transporter_name =data.transporter_name
        this.updatetransporterObj.transporter_emailid =data.transporter_emailid
        this.updatetransporterObj.transporter_mobilenumber =data.transporter_mobilenumber
        this.updatetransporterObj.gstnumber=data.transporter_gst_no
        this.updateInfo = !this.updateInfo;    
      },

      updatecheckGSTlength(value){
        if (value.length>0) {
          this.showverifybutton=true;
          document.getElementById("submitButton1").disabled = true; 
        }
        else{
          this.showverifybutton=false;
          this.updatetransporterObj.gstnumber='';
          this.update_errors_GST = false;
          this.update_errors_showGST= {};
          document.getElementById("submitButton1").disabled = false;
          this.updateremoveGST=false;
        }
      },

      updateverifyGSTNo(){
        document.getElementById("overlayModal").style.display = "block";
          const infoObj = {
            Gstin:this.updatetransporterObj.gstnumber,
          };
          console.log("infoObj",infoObj);
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validateGSTNO`, infoObj).then((result)=>{
            console.log("result",result)
            document.getElementById("overlayModal").style.display = "none";
            if (result.body === "success") {
              document.getElementById("submitButton1").disabled = false;
              this.showverifybutton=false;
              this.$fire({
                text: 'Successful Verify',
                type: "success",
                timer: 30000,
              });
              this.update_errors_GST = false;
              this.update_errors_showGST.transporter_gstnumber = '';
              this.update_removeGST=false;
            } else {
              this.update_errors_GST = true;
              this.update_errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
              this.update_removeGST=true;
            }
          }).catch((ex) => {
            console.log("error", ex);
          });

        // if (this.updatetransporterObj.gstnumber) {
        //   this.update_errors_GST = true;
        //   this.update_errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
        //   this.update_removeGST=true;
        //   return false;
        // }
        // else{
        //   document.getElementById("submitButton1").disabled = false;
        // }
      },

      updateremovevalue(){
        this.showverifybutton=false;
        this.updatetransporterObj.gstnumber='';
        this.update_errors_GST = false;
        this.update_errors_showGST= {};
        document.getElementById("submitButton1").disabled = false;
        this.update_removeGST=false;
      },

      editTransporterForm(scope){
        this.$validator.validateAll(scope).then((result) => {
        if (result) {
            this.editTransporterInfo();
        }
        });
      },
      clearSearch() {
        this.filter = '';
        this.getTransporterList();
        },

      editTransporterInfo(){
        document.getElementById("overlayModal").style.display = "block";
        let userdata = localStorage.getItem("userData");
        let userInfo = JSON.parse(userdata);
            const infoObj = {
                transporter_id:this.updatetransporterObj.transporter_id,
                transporter_company_name:this.updatetransporterObj.transporter_company_name,
                transporter_name:this.updatetransporterObj.transporter_name,
                transporter_emailid:this.updatetransporterObj.transporter_emailid,
                transporter_mobilenumber:this.updatetransporterObj.transporter_mobilenumber,
                transporter_gstnumber:`${this.updatetransporterObj.gstnumber}`,
                lastmodifiedby:`${userInfo.sysemailid}`,
                updated_from:'FTL'
               
            };
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateTransporterInfoNew`, infoObj).then((result)=>{
          document.getElementById("overlayModal").style.display = "none";
          if (result.body.returnmsg === "successful") {
            this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 30000,
            });
            this.updatetransporterObj={}
            this.updateInfo = false; 
            this.getTransporterList();      
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        }).catch((ex) => {
          console.log("error", ex);
        });
      }
    }
}
</script>
<style scoped>
.custom-close {
  background-color: #FF8D2C !important;
  border-radius: 10px !important;
}

.custom-submit {
  background-color: #20a8d8 !important;
  border-color: #20a8d8 !important;
  border-radius: 10px !important;  
}
</style>